module.exports = __webpack_public_path__ + "static/interhome_logo-d3a0fa43878e4e418b5e0db701901b74.svg";